import { SvgIcon as MuiSvgIcon, SvgIconProps as MuiSvgIconProps } from '@mui/material';
import React from 'react';

export type SvgIconProps = MuiSvgIconProps;

export const SvgIcon = (props: SvgIconProps) => <MuiSvgIcon {...props} />;
